import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';

import { useConfiguration } from '../../context/configurationContext';
import { types as sdkTypes } from '../../util/sdkLoader';
import { manageDisableScrolling } from '../../ducks/ui.duck';

import { ManageListingsPageComponent } from '../ManageListingsPage/ManageListingsPage';
import {
  closeListing,
  discardDraft,
  getOwnListingsById,
  loadListingCapContextThunk,
  openListing,
  saveManageListingsFilters,
} from '../ManageListingsPage/ManageListingsPage.duck';
import { queryPublishedListingsCountThunk } from './ProfilePage.duck';

const { UUID } = sdkTypes;

const OwnProfileManageListingsComponent = props => {
  const config = useConfiguration();
  const { profileId, onRefreshPublishedCount, ...rest } = props;

  return (
    <ManageListingsPageComponent
      {...rest}
      embedded
      profileId={profileId}
      onListingMutated={() => onRefreshPublishedCount(new UUID(profileId), config)}
    />
  );
};

const mapStateToProps = state => {
  const { currentUser } = state.user;
  const manageState = state.ManageListingsPage || {};
  const {
    currentPageResultIds,
    pagination,
    queryInProgress,
    queryListingsError,
    queryParams,
    openingListing,
    openingListingError,
    closingListing,
    closingListingError,
    discardingDraft,
    discardingDraftError,
    listingCap,
    hasFinishTableDrafts,
  } = manageState;

  return {
    currentUser,
    listings: state.ManageListingsPage ? getOwnListingsById(state, currentPageResultIds || []) : [],
    pagination,
    queryInProgress,
    queryListingsError,
    queryParams,
    openingListing,
    openingListingError,
    closingListing,
    closingListingError,
    discardingDraft,
    discardingDraftError,
    listingCap,
    hasFinishTableDrafts,
  };
};

const mapDispatchToProps = dispatch => ({
  onCloseListing: listingId => dispatch(closeListing(listingId)),
  onOpenListing: listingId => dispatch(openListing(listingId)),
  onLoadListingCap: config => dispatch(loadListingCapContextThunk({ config })).unwrap(),
  onDiscardDraft: listingId => dispatch(discardDraft(listingId)),
  onSaveManageListingsFilters: filters => dispatch(saveManageListingsFilters(filters)),
  onManageDisableScrolling: (componentId, disableScrolling) =>
    dispatch(manageDisableScrolling(componentId, disableScrolling)),
  onRefreshPublishedCount: (userId, config) =>
    dispatch(queryPublishedListingsCountThunk({ userId, ownProfileOnly: false, config })),
});

const OwnProfileManageListings = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(OwnProfileManageListingsComponent);

export default OwnProfileManageListings;
